import accountRouterItems from '@/modules/Account/routes/items'
import invoicingRouterItems from '@/modules/Invoicing/routes/items'
import { NavItemType } from './type'
import approvalsRouterItems from '@/modules/Approvals/routes/items'
import telemedicineRouterItems from '@/modules/Telemedicine/routes/items'
import dashboardRouterItems from '@/modules/Dashboard/routes/item'
import couponRouterItems from '@/modules/Coupon/routes/items'
import auditTrackerItems from '@/modules/AuditTracker/routes/items'
import usersRouterItems from '@/modules/Users/routes/items'
import medicalRecordTemplates from '@/modules/MedicalRecordTemplates/routes/Item'
import professionalsRouterItems from '@/modules/Professionals/routes/items'
import patientRouterItems from '@/modules/Patient/routes/items'

const menuItems: NavItemType[] = [
  ...dashboardRouterItems,
  ...usersRouterItems,
  ...professionalsRouterItems,
  ...patientRouterItems,
  ...invoicingRouterItems,
  ...accountRouterItems,
  ...approvalsRouterItems,
  ...telemedicineRouterItems,
  ...couponRouterItems,
  ...auditTrackerItems,
  ...medicalRecordTemplates,
]

export default menuItems
